export const isValidMeasurement = (
  measurement: string,
  t: (key: string) => string
): boolean | string => {
  const numeric = Number(measurement)

  if (numeric < 0) {
    return t('patients:errors.shouldBePositive')
  }

  if (/^0\d+/.test(measurement)) {
    return t('patients:errors.removeLeadingZeros')
  }

  if (!Number.isInteger(numeric)) {
    return t('patients:errors.shouldBeInteger')
  }
  if (numeric > 1000) {
    return t('patients:errors.maxValue')
  }

  return true
}

export const correctMeasurement = (value: string): string => {
  let numeric = Number(value)

  if (isNaN(numeric)) {
    return ''
  }

  if (numeric < 0) {
    numeric = Math.abs(numeric)
  }
  if (!Number.isInteger(numeric)) {
    numeric = Math.round(numeric)
  }
  if (numeric > 1000) {
    numeric = 1000
  }

  return String(numeric).replace(/^0+/, '') || '0'
}
